<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Statische Karte generieren

  section.modal-card-body
   ValidationObserver(ref="form")
   .generic-wrapper
      #map

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-primary(@click="saveMap()") Karte speichern
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js';
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
  props: {
    predata: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      marker: null,
      data: null
    }
  },
  methods: {
    addMarker(lngLat) {
      if (this.marker) this.marker.remove();

      this.marker = new mapboxgl.Marker({
      color: "#3182CE",
      draggable: true
      }).setLngLat(lngLat)
      .addTo(this.map);
    },
    saveMap() {
      this.$emit('update', {...this.data,
                            centerLatitude: this.map.getCenter().lat,
                            centerLongitude: this.map.getCenter().lng,
                            markerLatitude: this.marker.getLngLat().lat,
                            markerLongitude: this.marker.getLngLat().lng,
                            zoom: this.map.getZoom(),
                            bearing: this.map.getBearing(),
                            pitch: this.map.getPitch()
                          });
    }
  },
  mounted() {
    const self = this;
    this.data = JSON.parse(JSON.stringify(this.predata));
    
    mapboxgl.accessToken = 'pk.eyJ1IjoienVnZW5kZSIsImEiOiJja21xdWRpc3gwMWw5Mm5vNmJwbXh4ODlvIn0.rJBjT0RmwJ2tWEIepi2eUg';
    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/satellite-v9', // style URL
      center: this.data.centerLatitude ? [this.data.centerLongitude, this.data.centerLatitude] : [11.19628, 53.992220], // starting position [lng, lat]
      zoom: self.data.zoom, // starting zoom
      bearing: self.data.bearing, // starting zoom
      pitch: self.data.pitch, // starting zoom
    });
    if(this.data.markerLatitude) {
      this.addMarker([this.data.markerLongitude, this.data.markerLatitude]);
    }
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on('click', function(e) {
      // The event object (e) contains information like the
      // coordinates of the point on the map that was clicked.
      self.addMarker(e.lngLat);
    });
  }
}
</script>

<style lang="scss">
.mapboxgl-map {
    width: 1280px;
    height: 800px;
}
#map > div.mapboxgl-canvas-container.mapboxgl-interactive.mapboxgl-touch-drag-pan.mapboxgl-touch-zoom-rotate > canvas {
  width: 1280px !important;
  height: 800px !important;
}
</style>